'use strict';

var React = require('react');

const useEffectOnce = (effect) => {
    React.useEffect(effect, []);
};

exports.useEffectOnce = useEffectOnce;
//# sourceMappingURL=useEffectOnce-5d273a5b.js.map
